
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4340"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4340"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $1Knfl = parcelRequire("1Knfl");

var $kB2C5 = parcelRequire("kB2C5");

var $2TWNj = parcelRequire("2TWNj");
var $del55 = parcelRequire("del55");
var $6N6DO = parcelRequire("6N6DO");
var $iNPz2 = parcelRequire("iNPz2");
function $8612b8a3ea607a3d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8612b8a3ea607a3d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8612b8a3ea607a3d$var$_typeof(obj);
}
var $8612b8a3ea607a3d$var$_excluded = [
    "name",
    "escapedValue",
    "data",
    "path"
];
function $8612b8a3ea607a3d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8612b8a3ea607a3d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8612b8a3ea607a3d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8612b8a3ea607a3d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8612b8a3ea607a3d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8612b8a3ea607a3d$var$_defineProperty(obj, key, value) {
    key = $8612b8a3ea607a3d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8612b8a3ea607a3d$var$_toPropertyKey(arg) {
    var key = $8612b8a3ea607a3d$var$_toPrimitive(arg, "string");
    return $8612b8a3ea607a3d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8612b8a3ea607a3d$var$_toPrimitive(input, hint) {
    if ($8612b8a3ea607a3d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8612b8a3ea607a3d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8612b8a3ea607a3d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8612b8a3ea607a3d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8612b8a3ea607a3d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8612b8a3ea607a3d$var$_slicedToArray(arr, i) {
    return $8612b8a3ea607a3d$var$_arrayWithHoles(arr) || $8612b8a3ea607a3d$var$_iterableToArrayLimit(arr, i) || $8612b8a3ea607a3d$var$_unsupportedIterableToArray(arr, i) || $8612b8a3ea607a3d$var$_nonIterableRest();
}
function $8612b8a3ea607a3d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8612b8a3ea607a3d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8612b8a3ea607a3d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8612b8a3ea607a3d$var$_arrayLikeToArray(o, minLen);
}
function $8612b8a3ea607a3d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8612b8a3ea607a3d$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $8612b8a3ea607a3d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8612b8a3ea607a3d$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "hierarchical-menu",
    connector: true
});
var $8612b8a3ea607a3d$var$DEFAULT_SORT = [
    "name:asc"
];
/**
 * **HierarchicalMenu** connector provides the logic to build a custom widget
 * that will give the user the ability to explore facets in a tree-like structure.
 *
 * This is commonly used for multi-level categorization of products on e-commerce
 * websites. From a UX point of view, we suggest not displaying more than two
 * levels deep.
 *
 * @type {Connector}
 * @param {function(HierarchicalMenuRenderingOptions, boolean)} renderFn Rendering function for the custom **HierarchicalMenu** widget.
 * @param {function} unmountFn Unmount function called when the widget is disposed.
 * @return {function(CustomHierarchicalMenuWidgetParams)} Re-usable widget factory for a custom **HierarchicalMenu** widget.
 */ var $8612b8a3ea607a3d$var$connectHierarchicalMenu = function connectHierarchicalMenu(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $iNPz2.noop);
    (0, $2TWNj.checkRendering)(renderFn, $8612b8a3ea607a3d$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, attributes = _ref.attributes, _ref$separator = _ref.separator, separator = _ref$separator === void 0 ? " > " : _ref$separator, _ref$rootPath = _ref.rootPath, rootPath = _ref$rootPath === void 0 ? null : _ref$rootPath, _ref$showParentLevel = _ref.showParentLevel, showParentLevel = _ref$showParentLevel === void 0 ? true : _ref$showParentLevel, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 10 : _ref$limit, _ref$showMore = _ref.showMore, showMore = _ref$showMore === void 0 ? false : _ref$showMore, _ref$showMoreLimit = _ref.showMoreLimit, showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit, _ref$sortBy = _ref.sortBy, sortBy = _ref$sortBy === void 0 ? $8612b8a3ea607a3d$var$DEFAULT_SORT : _ref$sortBy, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (!attributes || !Array.isArray(attributes) || attributes.length === 0) throw new Error($8612b8a3ea607a3d$var$withUsage("The `attributes` option expects an array of strings."));
        if (showMore === true && showMoreLimit <= limit) throw new Error($8612b8a3ea607a3d$var$withUsage("The `showMoreLimit` option must be greater than `limit`."));
        // we need to provide a hierarchicalFacet name for the search state
        // so that we can always map $hierarchicalFacetName => real attributes
        // we use the first attribute name
        var _attributes = $8612b8a3ea607a3d$var$_slicedToArray(attributes, 1), hierarchicalFacetName = _attributes[0];
        var sendEvent;
        // Provide the same function to the `renderFn` so that way the user
        // has to only bind it once when `isFirstRendering` for instance
        var toggleShowMore = function toggleShowMore() {};
        function cachedToggleShowMore() {
            toggleShowMore();
        }
        var _refine;
        var isShowingMore = false;
        function createToggleShowMore(renderOptions, widget) {
            return function() {
                isShowingMore = !isShowingMore;
                widget.render(renderOptions);
            };
        }
        function getLimit() {
            return isShowingMore ? showMoreLimit : limit;
        }
        function _prepareFacetValues(facetValues) {
            return facetValues.slice(0, getLimit()).map(function(_ref2) {
                var label = _ref2.name, value = _ref2.escapedValue, data = _ref2.data, path = _ref2.path, subValue = $8612b8a3ea607a3d$var$_objectWithoutProperties(_ref2, $8612b8a3ea607a3d$var$_excluded);
                var item = $8612b8a3ea607a3d$var$_objectSpread($8612b8a3ea607a3d$var$_objectSpread({}, subValue), {}, {
                    value: value,
                    label: label,
                    data: null
                });
                if (Array.isArray(data)) item.data = _prepareFacetValues(data);
                return item;
            });
        }
        return {
            $$type: "ais.hierarchicalMenu",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($8612b8a3ea607a3d$var$_objectSpread($8612b8a3ea607a3d$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                toggleShowMore = createToggleShowMore(renderOptions, this);
                renderFn($8612b8a3ea607a3d$var$_objectSpread($8612b8a3ea607a3d$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                return state.removeHierarchicalFacet(hierarchicalFacetName).setQueryParameter("maxValuesPerFacet", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $8612b8a3ea607a3d$var$_objectSpread($8612b8a3ea607a3d$var$_objectSpread({}, renderState), {}, {
                    hierarchicalMenu: $8612b8a3ea607a3d$var$_objectSpread($8612b8a3ea607a3d$var$_objectSpread({}, renderState.hierarchicalMenu), {}, $8612b8a3ea607a3d$var$_defineProperty({}, hierarchicalFacetName, this.getWidgetRenderState(renderOptions)))
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref4) {
                var _this = this;
                var results = _ref4.results, state = _ref4.state, createURL = _ref4.createURL, instantSearchInstance = _ref4.instantSearchInstance, helper = _ref4.helper;
                var items = [];
                var canToggleShowMore = false;
                // Bind createURL to this specific attribute
                var _createURL = function _createURL(facetValue) {
                    return createURL(function(uiState) {
                        return _this.getWidgetUiState(uiState, {
                            searchParameters: state.resetPage().toggleFacetRefinement(hierarchicalFacetName, facetValue),
                            helper: helper
                        });
                    });
                };
                if (!sendEvent) sendEvent = (0, $6N6DO.createSendEventForFacet)({
                    instantSearchInstance: instantSearchInstance,
                    helper: helper,
                    attribute: function attribute(facetValue) {
                        var index = facetValue.split(separator).length - 1;
                        return attributes[index];
                    },
                    widgetType: this.$$type
                });
                if (!_refine) _refine = function _refine(facetValue) {
                    sendEvent("click:internal", facetValue);
                    helper.toggleFacetRefinement(hierarchicalFacetName, facetValue).search();
                };
                if (results) {
                    var facetValues = results.getFacetValues(hierarchicalFacetName, {
                        sortBy: sortBy,
                        facetOrdering: sortBy === $8612b8a3ea607a3d$var$DEFAULT_SORT
                    });
                    var facetItems = facetValues && !Array.isArray(facetValues) && facetValues.data ? facetValues.data : [];
                    // If the limit is the max number of facet retrieved it is impossible to know
                    // if the facets are exhaustive. The only moment we are sure it is exhaustive
                    // is when it is strictly under the number requested unless we know that another
                    // widget has requested more values (maxValuesPerFacet > getLimit()).
                    // Because this is used for making the search of facets unable or not, it is important
                    // to be conservative here.
                    var hasExhaustiveItems = (state.maxValuesPerFacet || 0) > getLimit() ? facetItems.length <= getLimit() : facetItems.length < getLimit();
                    canToggleShowMore = showMore && (isShowingMore || !hasExhaustiveItems);
                    items = transformItems(_prepareFacetValues(facetItems), {
                        results: results
                    });
                }
                return {
                    items: items,
                    refine: _refine,
                    canRefine: items.length > 0,
                    createURL: _createURL,
                    sendEvent: sendEvent,
                    widgetParams: widgetParams,
                    isShowingMore: isShowingMore,
                    toggleShowMore: cachedToggleShowMore,
                    canToggleShowMore: canToggleShowMore
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
                var searchParameters = _ref5.searchParameters;
                var path = searchParameters.getHierarchicalFacetBreadcrumb(hierarchicalFacetName);
                return $8612b8a3ea607a3d$var$removeEmptyRefinementsFromUiState($8612b8a3ea607a3d$var$_objectSpread($8612b8a3ea607a3d$var$_objectSpread({}, uiState), {}, {
                    hierarchicalMenu: $8612b8a3ea607a3d$var$_objectSpread($8612b8a3ea607a3d$var$_objectSpread({}, uiState.hierarchicalMenu), {}, $8612b8a3ea607a3d$var$_defineProperty({}, hierarchicalFacetName, path))
                }), hierarchicalFacetName);
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
                var uiState = _ref6.uiState;
                var values = uiState.hierarchicalMenu && uiState.hierarchicalMenu[hierarchicalFacetName];
                if (searchParameters.isConjunctiveFacet(hierarchicalFacetName) || searchParameters.isDisjunctiveFacet(hierarchicalFacetName)) return searchParameters;
                if (searchParameters.isHierarchicalFacet(hierarchicalFacetName)) var facet = searchParameters.getHierarchicalFacetByName(hierarchicalFacetName);
                var withFacetConfiguration = searchParameters.removeHierarchicalFacet(hierarchicalFacetName).addHierarchicalFacet({
                    name: hierarchicalFacetName,
                    attributes: attributes,
                    separator: separator,
                    rootPath: rootPath,
                    showParentLevel: showParentLevel
                });
                var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
                var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
                var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter("maxValuesPerFacet", nextMaxValuesPerFacet);
                if (!values) return withMaxValuesPerFacet.setQueryParameters({
                    hierarchicalFacetsRefinements: $8612b8a3ea607a3d$var$_objectSpread($8612b8a3ea607a3d$var$_objectSpread({}, withMaxValuesPerFacet.hierarchicalFacetsRefinements), {}, $8612b8a3ea607a3d$var$_defineProperty({}, hierarchicalFacetName, []))
                });
                return withMaxValuesPerFacet.addHierarchicalFacetRefinement(hierarchicalFacetName, values.join(separator));
            }
        };
    };
};
function $8612b8a3ea607a3d$var$removeEmptyRefinementsFromUiState(indexUiState, attribute) {
    if (!indexUiState.hierarchicalMenu) return indexUiState;
    if (!indexUiState.hierarchicalMenu[attribute] || indexUiState.hierarchicalMenu[attribute].length === 0) delete indexUiState.hierarchicalMenu[attribute];
    if (Object.keys(indexUiState.hierarchicalMenu).length === 0) delete indexUiState.hierarchicalMenu;
    return indexUiState;
}
var $8612b8a3ea607a3d$export$2e2bcd8739ae039 = $8612b8a3ea607a3d$var$connectHierarchicalMenu;



var $aqOVV = parcelRequire("aqOVV");
var $kMjUy = parcelRequire("kMjUy");
var $cNXNW = parcelRequire("cNXNW");
var $lHFYh = parcelRequire("lHFYh");

var $1qliK = parcelRequire("1qliK");
//
const $cf639a66cf5eb8be$var$ALGOLIA_APP_ID = "XS4X4GJGA8";
const $cf639a66cf5eb8be$var$ALGOLIA_API_KEY = "1b6bee0488dc899e58e57f748383e757";
const $cf639a66cf5eb8be$var$ALGOLIA_INDEX_NAME = "api_data_idx";
// setup the search client.
const $cf639a66cf5eb8be$var$searchClient = (0, $1Knfl.liteClient)($cf639a66cf5eb8be$var$ALGOLIA_APP_ID, $cf639a66cf5eb8be$var$ALGOLIA_API_KEY);
const $cf639a66cf5eb8be$var$search = (0, $kB2C5.default)({
    searchClient: $cf639a66cf5eb8be$var$searchClient,
    appId: $cf639a66cf5eb8be$var$ALGOLIA_APP_ID,
    indexName: $cf639a66cf5eb8be$var$ALGOLIA_INDEX_NAME,
    apiKey: $cf639a66cf5eb8be$var$ALGOLIA_API_KEY,
    insights: false
});
//
// Create the render function
const $cf639a66cf5eb8be$var$renderList = ({ items: items, createURL: createURL }, level = 0)=>`
  <ul class="list-inside ${level > 0 ? "pl-3" : ""}">
    ${items.map((item)=>`
          <li>
            <a
              href="${createURL(item.value)}"
              data-value="${item.value}"
              style="font-weight: ${item.isRefined ? "bold" : ""}"
            >
              ${item.label} <span class="text-gray-400 text-sm">(${item.count})</span>
            </a>
            ${item.data ? $cf639a66cf5eb8be$var$renderList({
            items: item.data,
            createURL: createURL
        }, level + 1) : ""}
          </li>
        `).join("")}
  </ul>
`;
const $cf639a66cf5eb8be$var$renderHierarchicalMenu = (renderOptions, isFirstRender)=>{
    const { items: items, isShowingMore: isShowingMore, refine: refine, canToggleShowMore: canToggleShowMore, toggleShowMore: toggleShowMore, createURL: createURL, widgetParams: widgetParams } = renderOptions;
    if (isFirstRender) {
        const list = document.createElement("div");
        const button = document.createElement("button");
        button.addEventListener("click", ()=>{
            toggleShowMore();
        });
        widgetParams.container.appendChild(list);
        widgetParams.container.appendChild(button);
        if (!canToggleShowMore) button.classList = "hidden";
    }
    const children = $cf639a66cf5eb8be$var$renderList({
        items: items,
        createURL: createURL
    });
    widgetParams.container.querySelector("div").innerHTML = children;
    widgetParams.container.querySelector("button").textContent = isShowingMore ? "Show less" : "Show more";
    [
        ...widgetParams.container.querySelectorAll("a")
    ].forEach((element)=>{
        element.addEventListener("click", (event)=>{
            event.preventDefault();
            refine(event.target.dataset.value);
        });
    });
};
// Create the custom widget
const $cf639a66cf5eb8be$var$customHierarchicalMenu = (0, $8612b8a3ea607a3d$export$2e2bcd8739ae039)($cf639a66cf5eb8be$var$renderHierarchicalMenu);
// *
// * Define the search widgets
// *   See: https://www.algolia.com/doc/api-reference/widgets/js/
// *
const $cf639a66cf5eb8be$var$widgets = [
    // setup base configuration
    (0, $kMjUy.default)({
        hitsPerPage: 51,
        distinct: true
    }),
    //
    // Create the menu heirarchy
    $cf639a66cf5eb8be$var$customHierarchicalMenu({
        container: document.querySelector("#refinement-geo"),
        attributes: [
            "geoHierarchy.lvl0",
            "geoHierarchy.lvl1",
            "geoHierarchy.lvl2",
            "geoHierarchy.lvl3"
        ],
        separator: " > ",
        sortBy: [
            "name:asc"
        ],
        limit: 99
    }),
    //
    // create stats area
    (0, $lHFYh.default)({
        container: "#stats"
    }),
    //
    // allow refinements to be cleared
    (0, $aqOVV.default)({
        container: "#clear-refinements",
        templates: {
            resetLabel ({ hasRefinements: hasRefinements }, { html: html }) {
                return html`<span class="text-sm text-blue-400">${hasRefinements ? "[ Reset ]" : ""}</span>`;
            }
        }
    }),
    //
    // the hits!
    //  https://www.algolia.com/doc/api-reference/widgets/hits/js/
    (0, $1qliK.customHits)({
        container: document.querySelector("#hits")
    }),
    //
    // this example will use pagination.
    (0, $cNXNW.default)({
        container: "#pagination",
        cssClasses: {
            root: "w-full",
            list: "flex justify-center",
            item: "mx-2 px-2",
            selectedItem: "bg-gray-200 underline",
            link: "text-blue-800"
        }
    })
];
$cf639a66cf5eb8be$var$search.addWidgets($cf639a66cf5eb8be$var$widgets);
$cf639a66cf5eb8be$var$search.start();


//# sourceMappingURL=navigation-geo.0d61a162.js.map
